import { Component, Vue } from 'vue-property-decorator'
import { queryHomeinsideMessage } from '@/api'
import { UserModule } from '@/store/modules/user'

@Component({ name: 'SystemMessagePage' })
export default class SystemMessagePage extends Vue {
  private messageList: any = []

  created () {
    this.queryMessage()
  }

  private async queryMessage () {
    const result: any = await queryHomeinsideMessage({})
    this.messageList = result
    await UserModule.GetMessageIsRead()
  }
}
